import React, { createContext, useContext, useState } from "react";
import { getAuthenticatedUser, logout } from "../services/apiService";

// import // defaultUser,
// defaultProperties,
// defaultRooms,
// defaultLeases,
// defaultArchives,
// defaultMessages,
// defaultConversations,
// defaultTransactions,
// defaultPublishedRooms,
// ("../data/dummyData");

const StateContext = createContext();

const initialQuestionState = {
  1: false,
  2: false,
  3: false,
  4: false,
  5: false,
  6: false,
  7: false,
  8: false,
  9: false,
  10: false,
};

const initialModalState = {
  manageProperty: false,
  addProperty: false,
  editProperty: false,
  manageRoom: false,
  addRoom: false,
  editRoom: false,
  manageBills: false,
  addBill: false,
  editBill: false,
  manageChores: false,
  addChore: false,
  editChore: false,
  manageExpenses: false,
  addExpense: false,
  editExpense: false,
  editPhotos: false,
  addRoommate: false,
  transactions: false,
  messages: false,
  endLease: false,
  publishRoom: false,
  changeEmail: false,
  verifyId: false,
  viewLease: false,
  tenantSignLease: false,
  landlordSignLease: false,
  makePayment: false,
  acceptPayment: false,
};

const initialAlertState = {
  deleteProperty: false,
  deleteRoom: false,
  deleteLease: false,
  deleteBill: false,
  deleteChore: false,
  removeFromPublished: false,
  archiveLease: false,
  newProfile: false,
  exitStripe: false,
  tenantUpgrade: false,
  propertyUpgrade: false,
  manageChores: false,
  manageBills: false,
  changeSubscription: false,
};

const initialErrorState = {
  street: "",
  city: "",
  state: "",
  zipCode: "",
  homeType: "",
  rooms: "",
};

const initialPaymentState = {
  leaseId: null,
  amount: null,
  customAmount: null,
  fees: 0,
  totalAmount: null,
  isCreditCard: false,
};

export const ContextProvider = ({ children }) => {
  const [activeMenu, setActiveMenu] = useState(false);
  const [showRoomSearch, setShowRoomSearch] = useState(false);
  const [activePopup, setActivePopup] = useState(false);
  const [popupDetails, setPopupDetails] = useState([]);
  const [activeIframe, setActiveIframe] = useState(false);
  const [faqClicked, setFaqClicked] = useState(initialQuestionState);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [modal, setModal] = useState(initialModalState);
  const [alert, setAlert] = useState(initialAlertState);
  const [user, setUser] = useState({});
  const [stripeSubscription, setStripeSubscription] = useState({});
  const [usersProperties, setUsersProperties] = useState([]);
  const [address, setAddress] = useState({});
  const [mailingAddress, setMailingAddress] = useState({});
  const [currentPropertyId, setCurrentPropertyId] = useState(null);
  const [rooms, setRooms] = useState([]);
  const [currentRoomId, setCurrentRoomId] = useState(null);
  const [leases, setLeases] = useState([]);
  const [leaseArchives, setLeaseArchives] = useState([]);
  const [transactions, setTransactions] = useState([]);
  const [balance, setBalance] = useState(null);
  const [notifications, setNotifications] = useState([]);
  const [messages, setMessages] = useState([]);
  const [conversations, setConversations] = useState([]);
  const [conversationId, setConversationId] = useState(null);
  const [messageRecipientId, setMessageRecipientId] = useState(null);
  const [chores, setChores] = useState([]);
  const [bills, setBills] = useState([]);
  const [expenses, setExpenses] = useState([]);
  const [publishedRooms, setPublishedRooms] = useState([]);
  const [errorAnimation, setErrorAnimation] = useState(initialErrorState);
  const [userLikesArray, setUserLikesArray] = useState([]);
  const [recentlyViewedRoomsArray, setRecentlyViewedRoomsArray] = useState([]);
  const [navigateToDashboard, setNavigateToDashboard] = useState(true);
  const [payment, setPayment] = useState(initialPaymentState);
  const [stripeConnectAccount, setStripeConnectAccount] = useState({});
  const [dualView, setDualView] = useState();

  const handleSearchDropdown = () => {
    setShowRoomSearch(!showRoomSearch);
  };

  const handleModal = (name) => {
    setModal({ ...modal, [name]: !modal[name] });
  };

  const handleAlert = (item) => {
    setAlert((prevState) => ({
      ...prevState,
      [item]: !alert[item],
    }));
  };

  const handleFaqClick = (clicked) => {
    setFaqClicked({ ...initialQuestionState, [clicked]: !faqClicked[clicked] });
  };

  const signup = (newUser) => {
    setIsLoggedIn(true);
    setUser(newUser); //set user
    handleAlert("newProfile");
  };

  const handleLogin = (data) => {
    // setIsLoggedIn(true); // set bearer token
    // setUser(defaultUser); //set user
    // setUsersProperties(defaultProperties); //set user properties
  };

  const handleVerification = (payload) => {
    if (payload.password === "567890") {
      return true;
    } else {
      console.log("Verification Failed");
      return false;
    }
  };

  const checkAuth = async () => {
    const response = await getAuthenticatedUser();
    if (response.hasError) {
      console.log(response.error);
      // handleLogout();
      return;
    } else {
      setIsLoggedIn(true);
      setUser(response.data.user);
      setUsersProperties(response.data.properties);
      setRooms(response.data.rooms);
      setPublishedRooms(response.data.publishedRooms);
      setLeases(response.data.leases);
      setConversations(response.data.conversations);
      setMessages(response.data.messages);
      setNotifications(response.data.notifications);
      setTransactions(response.data.transactions);
      setBalance(response.data.balance);
      setBills(response.data.bills);
      setChores(response.data.chores);
      setExpenses(response.data.expenses);
      setStripeSubscription(response.data.stripeSubscription);
      setStripeConnectAccount(response.data.stripeConnectAccount);
      setDualView(response.data.dualView);
    }
  };

  const handleLogout = async () => {
    if (await logout()) {
      localStorage.clear();
      setActiveMenu(false);
      setIsLoggedIn(false);
      setModal(initialModalState);
      //clear user
      //clear users properties
      console.log("logout successful");
    } else {
      console.log("logout error");
    }
  };

  const handleAddress = (event) => {
    const { name, value } = event.target;
    const reg = new RegExp("^[0-9]*$"); // is integers or empty?
    let safeValue;

    if (name === "zipCode") {
      if (reg.test(value)) {
        safeValue = value;
      } else {
        return;
      }
    }

    safeValue = value;

    if (name.split(" ")[1] === "address-search") {
      //Temp Fix: Mapbox Autocomplete appends 'address-search' to name.
      setAddress((prevState) => ({
        ...prevState,
        [name.split(" ")[0]]: safeValue,
      }));
    } else {
      setAddress((prevState) => ({ ...prevState, [name]: safeValue }));
    }
  };

  const resetAddress = () => {
    setAddress({
      homeType: "",
      neighborhood: "",
      street: "",
      street2: "",
      city: "",
      state: "--",
      zipCode: "",
      latitude: "",
      longitude: "",
    });
  };

  const checkPropertyAuth = () => {
    const type = stripeSubscription.type;
    switch (type) {
      case "basic":
        if (usersProperties.length < 1) return true;
        break;
      case "premium":
        if (usersProperties.length < 2) return true;
        break;
      case "founder":
        if (usersProperties.length < 6) return true;
        break;
      case "professional":
        return true;

      default:
        return false;
    }
  };

  const checkTenantAuth = () => {
    const type = stripeSubscription.type;
    switch (type) {
      case "basic":
        if (leases.length < 1) return true;
        break;
      case "premium":
        if (leases.length < 4) return true;
        break;
      case "founder":
        if (leases.length < 4) return true;
        break;
      case "professional":
        return true;

      default:
        return false;
    }
  };

  const hasErrors = (skipHomeType) => {
    if (!skipHomeType && address.homeType === "") {
      activateError("homeType");
    } else if (address.street === "") {
      activateError("street");
    } else if (address.city === "") {
      activateError("city");
    } else if (address.state === "--") {
      activateError("state");
    } else if (address.zipCode === "" || address.zipCode.length < 5) {
      activateError("zipCode");
    } else {
      return false;
    }
    return true;
  };

  const activateError = (item) => {
    setErrorAnimation((prevState) => ({
      prevState,
      [item]: "animate-shake text-red-600 border-red-600",
    }));
    setTimeout(() => {
      setErrorAnimation((prevState) => ({
        prevState,
        [item]: "",
      }));
    }, 500);
    clearTimeout();
  };

  return (
    <StateContext.Provider
      value={{
        user,
        setUser,
        stripeSubscription,
        setStripeSubscription,
        activeMenu,
        setActiveMenu,
        showRoomSearch,
        setShowRoomSearch,
        handleSearchDropdown,
        activePopup,
        setActivePopup,
        popupDetails,
        setPopupDetails,
        activeIframe,
        setActiveIframe,
        faqClicked,
        setFaqClicked,
        handleFaqClick,
        isLoggedIn,
        setIsLoggedIn,
        signup,
        handleLogin,
        handleVerification,
        checkAuth,
        handleLogout,
        modal,
        setModal,
        alert,
        setAlert,
        handleModal,
        handleAlert,
        currentPropertyId,
        setCurrentPropertyId,
        currentRoomId,
        setCurrentRoomId,
        address,
        setAddress,
        handleAddress,
        mailingAddress,
        setMailingAddress,
        resetAddress,
        usersProperties,
        setUsersProperties,
        rooms,
        setRooms,
        leases,
        setLeases,
        leaseArchives,
        setLeaseArchives,
        transactions,
        setTransactions,
        balance,
        setBalance,
        notifications,
        setNotifications,
        messages,
        setMessages,
        conversations,
        setConversations,
        conversationId,
        setConversationId,
        messageRecipientId,
        setMessageRecipientId,
        chores,
        setChores,
        bills,
        setBills,
        expenses,
        setExpenses,
        publishedRooms,
        setPublishedRooms,
        errorAnimation,
        setErrorAnimation,
        hasErrors,
        activateError,
        userLikesArray,
        setUserLikesArray,
        recentlyViewedRoomsArray,
        setRecentlyViewedRoomsArray,
        navigateToDashboard,
        setNavigateToDashboard,
        payment,
        setPayment,
        stripeConnectAccount,
        setStripeConnectAccount,
        dualView,
        checkPropertyAuth,
        checkTenantAuth,
      }}
    >
      {children}
    </StateContext.Provider>
  );
};

export const useStateContext = () => useContext(StateContext);
